// Formatação de números no padrão brasileiro. Tudo em R$ (decisão de 23/09/2026:
// todas as contas de anúncio reportam em reais).

const reais = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
const reaisCompacto = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  notation: 'compact',
  maximumFractionDigits: 1,
})
const inteiro = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 })
const compacto = new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 })
const umaCasa = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 })
const duasCasas = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

/** R$ 1.234,56 */
export const formatarReais = (v: number) => reais.format(v)

/** R$ 12,9 mil a partir de 10 mil; abaixo disso, o valor cheio. */
export const formatarReaisCompacto = (v: number) =>
  Math.abs(v) >= 10_000 ? reaisCompacto.format(v) : reais.format(v)

const reaisInteiros = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 })

/** Para eixo de gráfico: sem centavos (R$ 600), compacto a partir de 10 mil. */
export const formatarReaisEixo = (v: number) =>
  Math.abs(v) >= 10_000 ? reaisCompacto.format(v) : reaisInteiros.format(v)

/**
 * Marcas de eixo em números redondos (passo 1, 2 ou 5 × 10ⁿ), de 0 até cobrir o máximo.
 * O automático do Recharts às vezes cai em 55 / 110 / 165.
 */
export function marcasDeEixo(maximo: number, alvo = 4): number[] {
  if (!(maximo > 0)) return [0, 1]
  const bruto = maximo / alvo
  const potencia = 10 ** Math.floor(Math.log10(bruto))
  const passo = ([1, 2, 5, 10].find((m) => m * potencia >= bruto) ?? 10) * potencia
  const topo = Math.ceil(maximo / passo) * passo
  return Array.from({ length: Math.round(topo / passo) + 1 }, (_, i) => Number((i * passo).toPrecision(12)))
}

/** 1.234 · 12,9 mil a partir de 10 mil. */
export const formatarNumero = (v: number) =>
  Math.abs(v) >= 10_000 ? compacto.format(v) : inteiro.format(v)

/** Contagem inteira com milhar — para colunas de tabela, sem compactar. */
export const formatarInteiro = (v: number) => inteiro.format(v)

/** Conversões: o Google atribui frações, então até uma casa decimal. */
export const formatarConversoes = (v: number) =>
  Math.abs(v) >= 10_000 ? compacto.format(v) : umaCasa.format(v)

/** Recebe a fração (0,0123) e devolve "1,23%". */
export const formatarPercentual = (fracao: number) => `${duasCasas.format(fracao * 100)}%`

/** Posição média na busca, uma casa: "8,4". */
export const formatarPosicao = (v: number) => umaCasa.format(v)

/** ROAS como múltiplo do investimento: "3,25×". */
export const formatarRoas = (v: number) => `${duasCasas.format(v)}×`

/** Divisão que devolve null em vez de Infinity/NaN — "—" na tela. */
export const razao = (a: number, b: number): number | null => (b ? a / b : null)
